<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="chap1"><a id="start">Prologue</a></h1><a id="start">
<p class="center" style="margin-top:30px;"><span><i>O little town of Bethlehem</i></span></p>
<p class="center"><span><i>How still we see thee lie…</i></span></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 4-chap1.vue?132a5142